import { render, staticRenderFns } from "./BrowserError.vue?vue&type=template&id=9b35c2a2&"
import script from "./BrowserError.vue?vue&type=script&lang=js&"
export * from "./BrowserError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports